// Keep the dictionary rule format. Callers explicitly opt into the new model.
export const statementAnswersVisibilityRows = rows => rows.map(row => ({
    id: row.statementId,
    coveredExcluded: row.answer,
}))
